module.exports = __webpack_public_path__ + "static/media/p2008right.bfa5a3e5.jpg";